module.exports = __webpack_public_path__ + "site/img/index1en11.5e6c54bb.png";